import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import { getQryAccountInfo, callGetCustomerInfo } from '@api';

const initialState = {
    currentTab: 'ACCOUNT_INFO',
    startDate: new Date(),
    endDate: new Date(),
    creditLine: 0,
    collateralMarketValue: 0,
    financingAmount: 0,
    borrowingAmount: 0,
    borrowedAmount: 0,
    sumEstimateInterest: 0,
    subTotalInterest: 0,
    interestRate: 0,
    maintenanceRate: 0,
    contractExpiryDate: '',
    rateEfficientDate: '',
    lendUI: [],
    lendDetailUIList: [],
};

const api = {
    qryAccountInfo: getQryAccountInfo,
    getInfo: callGetCustomerInfo,
};
const AccountingStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getAccountInfo(startDate, endDate, queryType) {
            const params = {
                startDate,
                endDate,
                queryType,
            };
            const infoRes = await this.getInfo();
            const account = infoRes.data.item.account;
            const res = await this.qryAccountInfo(params);
            const userAccountInfo = res.item;
            this.assignData({ ...userAccountInfo });
        },
        setOpen({ index, value }) {
            this.lendDetailUIList[index].open = value;
        },
    })); // 3

export default AccountingStore; // 2
